import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import Teamsetup from "../../components/Teamsetup";
import CreateGame from "../../components/CreateGame";
import NavBack from "../../components/NavBack/NavBack";
import { TEAM_COLORS } from "../../constants";
import {
  showLoading,
  showAlert,
  apiRequest,
  PLAYER_URL_PREFIX,
} from "../../utils";
import { QRCodeModalComponent } from "../../components/QRCodeModal/QRCodeModal";
import QRCodeModal from "../../components/QRCodeModal/QRCodeModal";

import ss from "./Prepare.module.css";

export default function Prepare() {
  const sessionUUID = new URLSearchParams(window.location.search).get(
    "session_uuid"
  );

  const [active, setActive] = useState(false); //按钮高亮状态

  const [Teamsetup_start, setTeamsetup_start] = useState(false); //队伍设置页面显示状态
  const [Create_popup, setCreate_popup] = useState(false); //调整游戏弹框

  const [team_id, setTeam_Id] = useState(0); //队伍id
  const [teamList, setTeamList] = useState([]);

  // 调整游戏弹框;
  const open_create = () => {
    setCreate_popup(true);
  };
  const clone_create = () => {
    setCreate_popup(false);
  };

  // 修改配置
  const change_config = () => {
    //这里是修改配置逻辑
    getTeamList();
  };

  //关闭队伍设置页面
  const closeTeamsetup = () => {
    getTeamList();
    setTeamsetup_start(false);
  };

  //点击按钮，显示队伍设置页面
  const showTeamsetup = (v) => {
    console.log("修改的队伍", v);
    setTeam_Id(v);
    setTeamsetup_start(true);
  };

  const navigate = useNavigate();

  const signOut = () => {
    navigate(`/await?session_uuid=${sessionUUID}`);
  };

  // 跳转准备页面
  const jump = () => {
    if (!active) return;
    signOut();
  };

  const getTeamList = () => {
    const loading = showLoading("加载中");
    apiRequest("/get_team_list", "GET", {
      session_uuid: sessionUUID,
    })
      .then((res) => {
        if (res.code === 0) {
          setTeamList(res.teams);
          if (res.teams.every((v) => v.name)) setActive(true);
        } else {
          showAlert(res.msg);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => loading.hide());
  };

  useEffect(() => {
    getTeamList();
    // eslint-disable-next-line
  }, []);

  if (teamList.length === 0) return <></>;

  return (
    <div className={ss.bg}>
      <div className={ss.title}>
        <div className={ss.card_box}>
          {teamList.map((value, index) => {
            return (
              <div
                className={ss.card}
                key={index}
                onClick={() => {
                  showTeamsetup(value);
                }}
              >
                <img
                  src={require(`../../components/Avatar/img/color${value.color}.png`)}
                  alt=""
                />
                <div
                  className={ss.inp_txt}
                  style={{ color: TEAM_COLORS[value.color] }}
                >
                  【{value.name || "未设置名称"}】
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={ss.select_box}>
        <div
          className={ss.prepareBtn}
          onClick={() => {
            open_create();
          }}
        >
          调整配置
        </div>
        <div
          className={ss.prepareBtn}
          onClick={() => {
            QRCodeModal.show({
              type: "report",
              url: `${PLAYER_URL_PREFIX}/report?sid=${sessionUUID}`,
              onClose: () => {
                QRCodeModal.hide();
              },
            });
          }}
        >
          花絮二维码
        </div>
        <div
          className={ss.prepareBtn}
          onClick={() => {
            QRCodeModal.show({
              type: "login",
              url: `${PLAYER_URL_PREFIX}/login?sid=${sessionUUID}`,
              onClose: () => {
                QRCodeModal.hide();
              },
            });
          }}
        >
          登录二维码
        </div>
        <div
          className={classNames(ss.prepareBtn, !active && ss.disabled)}
          onClick={() => {
            jump();
          }}
        >
          进入后台
        </div>
      </div>
      {Create_popup && (
        <CreateGame
          clone={clone_create}
          new_card={(v) => {
            change_config(v);
          }}
          pass={true}
          session_uuid={sessionUUID}
        />
      )}

      <NavBack onClick={() => navigate("/Host")} />
      {Teamsetup_start && <Teamsetup clone={closeTeamsetup} team={team_id} />}
      <QRCodeModalComponent />
    </div>
  );
}
